import React, { FC } from "react";
import Pagination from "shared/Pagination/Pagination";
import TabFilters from "./TabFilters";
import Heading2 from "components/Heading/Heading2";
import ItemCard from "components/ItemCard/ItemCard";
import { ManyItem } from "types/interfaces";
import ItemCardLoading from "components/ItemCard/ItemCardLoading";

export interface SectionGridFilterCardProps {
  className?: string;
  data?: ManyItem[];
  heading?: string;
  location?: string;
  error?: boolean;
  page: number;
  query?: string;
  loading?: boolean;
}

const SectionGridFilterCard: FC<SectionGridFilterCardProps> = ({
  className = "",
  data,
  heading = "",
  loading,
  location = "Bali",
  error = false,
  page = 1,
}) => {
  const toUppercase = (category: string) => {
    return category.charAt(0).toUpperCase() + category.slice(1);
  };

  return (
    <div
      className={`nc-SectionGridFilterCard ${className}`}
      data-nc-id="SectionGridFilterCard"
    >
      <Heading2
        heading={`${toUppercase(heading)}`}
        subHeading={
          <span className="block text-neutral-500 dark:text-neutral-400 mt-3">
            Hasil pencarian: {data?.length || ""}{" "}
            {data && data.length > 0 ? heading : "Barang Tidak Ditemukan"}
          </span>
        }
      />

      <div className="mb-8 lg:mb-11">
        <TabFilters />
      </div>
      {loading ? (
        <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {[1, 2, 3, 4, 5, 6, 7, 8].map((item) => (
            <ItemCardLoading key={item}></ItemCardLoading>
          ))}
        </div>
      ) : data ? (
        <div className="grid grid-cols-1 gap-6 md:gap-8 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4">
          {data.slice(page * 8, page * 8 + 8).map((item) => (
            <ItemCard key={item._id} data={item} />
          ))}
        </div>
      ) : (
        <div></div>
      )}
      {error && <h1>Produk Tidak Ditemukan</h1>}
      <div className="flex mt-16 justify-center items-center">
        <Pagination current={page} length={data ? data.length : 0} />
      </div>
    </div>
  );
};

export default SectionGridFilterCard;
